"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isDefined = void 0;
function isDefined(val) {
    return val !== null && val !== undefined;
}
exports.isDefined = isDefined;
